import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Container from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import loadable from '@loadable/component';
import {Carousel} from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import ReactPlayer from 'react-player';
import CircleControls from 'react-player-circle-controls';
import 'react-player-circle-controls/dist/styles.css';
import MuiMarkdown from 'mui-markdown';
import { isTiny, isSmall, isMedium, isLarge} from '../layout/reactive';
import {useReactive} from "../layout/reactive";
import Image from 'mui-image';
import Logo from '../layout/alba-v.svg';

const Bottom = loadable(() => import('../layout/bottom'));
const Contribucione = loadable(() => import('./Contribucione'));

const host =  process.env.REACT_APP_API;
const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.stack,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const AlertDialog = () => {
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog
        fullScreen
        open={open}
        onClose={()=>handleClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"

      >
      <Box sx={{ alignItems: 'center', minHeight: '100vh', justifyContent:'center', flexDirection: 'column', display:'flex'}}>
      <Container maxWidth='sm' >
        <DialogTitle id="alert-dialog-title" sx={{justifyContent: 'center' }}>
          <Image fit="contain" width="100%" height="160px" src={Logo} alt="logo" />
          <Typography align='center' color='textPrimary' variant="h3"  component="div" sx={{ pt: 4, pb: 2}}>{"Bienvenidos y bienvenidas a “Alba”, la audioguía de las memorias del Municipio B.  "}</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography align='center' color='textPrimary'  variant="body1" component="div"> Se trata de un proyecto colaborativo y de anclaje territorial, que busca contribuir a la construcción de memoria colectiva en clave de derechos humanos, a partir de la identificación y georreferenciación de lugares marcados por hechos de represión estatal o de resistencia durante el último período de terrorismo de Estado en Uruguay.</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{justifyContent: 'center' }}>
          <Button color='secondary' sx={{maxWidth: 400}} size="large" align="center"  variant="contained" onClick={() => handleClose()} autoFocus>
            Comenzar
          </Button>
        </DialogActions>
        </Container>
        </Box>
     </Dialog>
  );
}
const ContribucioneDialog = () => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const toggleDialog = () => setOpen(!open);
  return (
    <>
    <Button size="large" variant="contained" onClick={() => toggleDialog()} >¿Quieres aportar a este relato?</Button>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Contribucione"}
          <Typography variant="body1">Dejá tu información y aportes, para ponernos en contacto.</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          <Box sx={{width:'100%'}}>
            <Contribucione />
          </Box>
          </DialogContentText>
        </DialogContent>
     </Dialog>
     </>
  );
};

const Memoria = () => {

  let params = useParams();

  let title = params?.name?.replace(/_/g, ' ');
  // hack for bad url 
  title = (title === " FUSNA") ? "Prefectura Nacional Naval DIPRE  FUSNA" : title;
  const [id, setId] = useState();

  const [memoria, setMemoria] = useState(null);
  const player = useRef(null);
  const [playing, setPlaying] = useState(false);
  const {isLarge, isMedium, isSmall } = useReactive();

  const [playerState, setPlayerState] = useState({
    played: 0,
    loaded: 0
  });

  const onSeek = amount => {
    if (player.current) {
      player.current.seekTo(amount, 'fraction');
    }
  };

  useEffect(() => {
    const getMemoria = async () => {
      try {
        await fetch('https://api.alba.gub.uy/memorias?Titulo='+encodeURI(title),
        {
          method: 'GET',
          mode: 'cors',
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          if (response && !response.ok) { throw new Error(response.statusText);}
          return response.json()
        })
        .then(data => {
          if(data) {
            setMemoria(data[0]);
          } else {
            console.log('No Data received from the server');
          }
        });

      } catch(e) {
        console.log(e.message);
      }
    }
    getMemoria();
  }, [title]);

  return (
    <>
    <AlertDialog />
    {memoria &&
          <>

        <Box sx={{width:'100vw', height:'87vh', overflow:'scroll', flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent:'flex-start', alignItems:'center'}} bgcolor="background.default">

        <Container maxWidth="xl" >

          <Box sx={{ flexGrow: 1, py: {xs: 2, md:4, lg:15},  px: {xs: 1, md:2, lg:0}, display: 'flex', flexDirection: {xs:'column', md:'row'}, alignItems:'center', color: 'primary.contrastText', height: {xs:'100vh', md:'40vh'} }}>

            <Box sx={{ flexGrow: 1, p:{xs: 2, md:0}}}>
              {/** Dibujo **/}
              {memoria && memoria.Dibujo && memoria.Dibujo.formats.thumbnail &&
              <Box sx={{pt:{xs: 1, md:6, lg:6}, px:{xs: 1, md:2, lg:4}, flexGrow: 1, display: 'flex', justifyContent: 'center'}}>
                <Avatar  sx={{ width: { xs: 120, sm: 180, md: 240}, height: { xs: 120, sm: 180, md: 240}, border: 6, borderColor: 'primary.contrastText' }} src={host+memoria.Dibujo.formats.thumbnail.url} />
              </Box>
              }
              {/** AUDIO **/}
              {memoria && memoria.Audio &&
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p:2 }}>
                  <ReactPlayer
                    ref={player}
                    url={host+memoria.Audio.url}
                    playing={playing}
                    height="0"
                    width="0"
                    onProgress={setPlayerState}
                    onEnded={() => setPlaying(false)}
                  />
                  <CircleControls
                    played={playerState.played}
                    loaded={playerState.loaded}
                    playing={playing}
                    iconColor="#005193"
                    color = '#16bf5a'
                    onSeek={onSeek}
                    onTogglePlaying={() => setPlaying(!playing)}
                    size={100}
                  />
                </Box >
              }
            </Box>
            <Box sx={{ flexGrow: {xs: 3, md:2, lg:1}, px: {xs: 4, md:4, lg:8}, textAlign:{xs:'center', md: 'left'}}}>
                {/** title **/}
                <Typography variant="h1" component="h1" sx={{py:0}} >{title}</Typography>

                {/** Fecha_del_acontecimiento **/}
                {memoria && memoria.Fecha_del_acontecimiento &&
                  <Typography sx={{pb:2}} variant="subtitle2" color="textSecondary" component="div">
                    {memoria.Fecha_del_acontecimiento}
                  </Typography>
                }

                  {/** Resumen_del_relato **/}
                  {memoria && memoria.Resumen_del_relato &&
                    <>
                    <Typography sx={{pb:4}}  variant="body1">
                     {memoria.Resumen_del_relato}
                   </Typography>
                    </>
                  }
                  {/** Categorias **/}
                  {memoria && memoria.categorias && memoria.categorias.length > 0 &&
                    <Stack
                      direction={{ xs: 'row', sm: 'row' }}
                      spacing={{ xs: 0.5, sm: 1, md: 2}}
                      justifyContent={{ xs: 'center', md: 'flex-start' }}
                      alignItems="center">
                      {memoria.categorias.map((c,i) => (
                        <Item key={"i"+i} elevation={0}  sx={{cursor: 'pointer', bgcolor: 'background.default', display: 'flex', alignItems: 'center', justifyContent: 'space-around'}} >
                        <Avatar key={"a"+i}  sx={{ mx:1, width: { xs: 24, md: 36}, height: {xs: 24, md: 36}, border: 0, borderColor: 'primary.contrastText' }} src={host+c.icon.formats.thumbnail.url} />
                        {c.Nombre}</Item>
                      ))}
                    </Stack>
                  }
            </Box>
            <Box sx={{ flexGrow: 0, pb: {xs:4, md:1},  pt: 4, minWidth: {xs:240, md: 280, lg: 360}, height: {xs:120, md: 200} } }>
              {/** VIDEO LSU **/}
              {memoria && memoria.Video &&
                <ReactPlayer height='100%' width='100%' config={{youtube: { playerVars: { showinfo: 0 } } }} previewTabIndex={0} muted={true} controls={true} light={true} url={memoria.Video} />
                  }
            </Box>
          </Box>
          </Container>


          <Box sx={{ width:'100vw', color: 'primary.contrastText', pb:8, bgcolor: 'background.translucid'}} >

            <Box sx={{width:'100vw', display:'flex', flexDirection: 'column', alignItems:'center' }}>
              <Container maxWidth="xl" >
                <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0 }} sx={{ bgcolor: 'background.translucid'}}>
                    <Grid item xs={12} md={4} sx={{boxShadow: 0}} bgcolor="primary.dark">
                      {/** Photos **/}
                      {memoria && memoria.Fotos && memoria.Fotos.length > 0 &&
                        <Carousel showArrows={true} showIndicators={true} infiniteLoop autoPlay showThumbs={false} >
                        {memoria.Fotos.map((p,i) => {
                          const pic = (isLarge) ? 'large' : (isMedium) ? 'large' : (isSmall) ? 'small' : 'thumbnail';
                          const url = (p.formats[pic]) ? host+p.formats[pic].url : host+p.formats.thumbnail.url ;
                          return (
                          <div key={i}>
                            {url && <Image key={"i"+i} src={url}/>}
                          </div>)}
                        )}
                        </Carousel>
                      }
                    </Grid>
                    <Grid item xs={12} md={8} sx={{boxShadow: 0, p: {xs:3, md: 6, lg:8}, lineHeight: 1.56}}>
                      {/** Relato completo **/}
                      {memoria && memoria.Relato_completo &&
                        <MuiMarkdown key='m2'>{memoria.Relato_completo}</MuiMarkdown>
                      }
                    </Grid>
                </Grid>
              </Container>
            </Box>

            <Box sx={{py: 6, px: 0, width:'100vw', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }} bgcolor="primary.light" color="primary.main">
                <Grid container rowSpacing={0} columnSpacing={{ xs: 2, md: 8}} sx={{ maxWidth: 1550, alignItems: 'flex-start', flexDirection: 'center', selfAlign: 'center'}}>
                    <Grid item xs={12} md={6} sx={{boxShadow: 0}}>
                    {/** personnas **/}
                    {memoria && memoria.personnas &&
                      <>
                      <Typography variant="h4" sx={{p: 2, pb:4}}>Personas detenidas</Typography>
                      <Stack
                        direction={{ xs: 'column'}}
                        spacing={{ xs: 1, sm: 2, md: 2 }}
                        justifyContent="flex-start"
                        alignItems={{ xs: 'flex-start' }}>
                        {memoria.personnas.map((c,i) => (
                          <Item key={i} elevation={0} sx={{px:4, py:0, cursor: 'pointer', textAlign: 'left', bgcolor: 'primary.light', display: 'flex', flexDirection:'column', alignItems:'flex-start'}} >
                            <Typography variant="body1" sx={{color:'primary.main', fontWeight:'Bold', textTransform: 'initial', p:0}}>{c.Nombre} {c.Apellido}</Typography>
                            <Typography variant="body2" sx={{color:'primary.main', textTransform: 'initial', p:0}}>{c.Edad} años </Typography>
                          </Item>
                        ))}
                      </Stack>
                      </>
                    }
                    </Grid>

                    <Grid item xs={12} md={6} sx={{boxShadow: 0, px:2}}>
                    <Typography variant="h4" sx={{p: 2, pb:4}}>Créditos </Typography>

                      <Box sx={{boxShadow: 0, px:3}}>
                        {/** Extra **/}
                        {memoria && memoria.Extra &&
                          <Typography variant="body1" sx={{color:'primary.main', textTransform: 'initial'}}>
                            <MuiMarkdown key='m3' >{memoria.Extra}</MuiMarkdown>
                          </Typography>
                        }
                      </Box>
                      <Box sx={{boxShadow: 0, px:3}}>
                        {/** Bibliografia **/}
                        {memoria && memoria.Bibliografia &&
                          <Typography variant="body1" sx={{color:'primary.main', textTransform: 'initial'}}>
                            <MuiMarkdown key='m4'>{memoria.Bibliografia}</MuiMarkdown>
                          </Typography>
                        }
                      </Box>
                    </Grid>

                </Grid>
            </Box>

            <Box bgcolor="secondary.main"  sx={{py: {xs:2, md:4 }, width:'100vw', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md:0}} sx={{ maxWidth: 1500, alignItems: 'center', flexDirection: 'center', selfAlign: 'center' }}>
                <Grid item xs={12} md={12} sx={{p:{xs: 2}, boxShadow: 0}}>
                  <Item elevation={0} sx={{bgcolor:'secondary.main', textTransform: 'none'}}>
                    {/** colectivo investigatores **/}

                    {memoria && memoria.colectivos &&
                      <>
                      <Typography variant="h4" sx={{pb: 4, textAlign: 'left'}}> Investigación realizada por </Typography>
                      <Stack
                        direction={{ xs: 'row', sm: 'row' }}
                        spacing={{ xs: 1, sm: 2, md: 4 }}
                        justifyContent="flex-start"
                        alignItems={{ xs: 'flex-start', sm: 2, md: 4 }}
                        sx={{py:{xs: 2, md: 2 }}}
                        >
                        {memoria.colectivos.map((c,i) => (
                          <Item key={i}  elevation={0} sx={{cursor: 'pointer', textAlign: 'left', bgcolor: 'secondary.main', display: 'flex', flexDirection:'row', alignItems:'center', maxWidth: 300}} >
                            <Image  key={"i"+i} style={{mixBlendMode: 'multiply', p:10}} src={host+c.Logo.formats.thumbnail.url} height='35%' width='35%' sx={{pr:5}}/>
                            {c.Nombre}
                          </Item>
                        ))}
                      </Stack>
                      </>
                    }
                    </Item>
                  </Grid>
                  <Grid item xs={12} md={12} sx={{ p:{xs: 3, md: 4 }, boxShadow: 0, display: 'flex', justifyContent:'center',  flexDirection:'column' }}>
                      <ContribucioneDialog />
                  </Grid>
            </Grid>
            </Box>


          </Box>
        </Box>
      <Bottom />
    </>
  }
  </>
  )
}

export default Memoria;
